module.exports = __webpack_public_path__ + "img/norson.f66d2ca2.png";